/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliverFeeInternationalListRespVo } from './GetDeliverFeeInternationalListRespVo';
import {
    GetDeliverFeeInternationalListRespVoFromJSON,
    GetDeliverFeeInternationalListRespVoFromJSONTyped,
    GetDeliverFeeInternationalListRespVoToJSON,
    GetDeliverFeeInternationalListRespVoToJSONTyped,
} from './GetDeliverFeeInternationalListRespVo';

/**
 * 
 * @export
 * @interface FreightCalculatorFeeGroupVo
 */
export interface FreightCalculatorFeeGroupVo {
    /**
     * 序号：1-5，对应运输方式
     * @type {number}
     * @memberof FreightCalculatorFeeGroupVo
     */
    index?: number;
    /**
     * 该运输方式下的国际运费信息列表
     * @type {Array<GetDeliverFeeInternationalListRespVo>}
     * @memberof FreightCalculatorFeeGroupVo
     */
    feeList?: Array<GetDeliverFeeInternationalListRespVo>;
}

/**
 * Check if a given object implements the FreightCalculatorFeeGroupVo interface.
 */
export function instanceOfFreightCalculatorFeeGroupVo(value: object): value is FreightCalculatorFeeGroupVo {
    return true;
}

export function FreightCalculatorFeeGroupVoFromJSON(json: any): FreightCalculatorFeeGroupVo {
    return FreightCalculatorFeeGroupVoFromJSONTyped(json, false);
}

export function FreightCalculatorFeeGroupVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreightCalculatorFeeGroupVo {
    if (json == null) {
        return json;
    }
    return {
        
        'index': json['index'] == null ? undefined : json['index'],
        'feeList': json['feeList'] == null ? undefined : ((json['feeList'] as Array<any>).map(GetDeliverFeeInternationalListRespVoFromJSON)),
    };
}

export function FreightCalculatorFeeGroupVoToJSON(json: any): FreightCalculatorFeeGroupVo {
    return FreightCalculatorFeeGroupVoToJSONTyped(json, false);
}

export function FreightCalculatorFeeGroupVoToJSONTyped(value?: FreightCalculatorFeeGroupVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'index': value['index'],
        'feeList': value['feeList'] == null ? undefined : ((value['feeList'] as Array<any>).map(GetDeliverFeeInternationalListRespVoToJSON)),
    };
}

